import classnames from 'classnames';
import React, { HTMLAttributes, ReactNode } from 'react';

import styles from './DropdownListItem.module.scss';

export interface DropdownItem {
  label: ReactNode;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  badge?: ReactNode;
  supportiveText?: string;
  separated?: boolean;
}

export interface DropdownListItemProps
  extends DropdownItem,
    HTMLAttributes<HTMLDivElement> {
  isActive: boolean;
  isFocused: boolean;
  isDisabled?: boolean;
}

export const DropdownListItem = ({
  label,
  leadingIcon,
  trailingIcon,
  badge,
  supportiveText,
  isActive,
  isFocused,
  separated = false,
  isDisabled = false,
  className,
  ...rest
}: DropdownListItemProps) => {
  return (
    <>
      <div
        data-testid="dropdown-list-item"
        role="option"
        aria-selected={!!isActive}
        aria-disabled={!!isDisabled}
        className={classnames(styles.item, className, {
          [styles.isActive]: isActive,
          [styles.isFocused]: isFocused,
          [styles.isCondensed]: !!badge,
          [styles.isDisabled]: isDisabled,
        })}
        {...rest}
      >
        {leadingIcon && (
          <div
            className={classnames(styles.leadingIconContainer, {
              [styles.isActive]: isActive,
            })}
          >
            {leadingIcon}
          </div>
        )}
        <p
          className={classnames(styles.mainLabel, {
            [styles.isActive]: isActive,
          })}
        >
          {label}
        </p>
        {badge}
        {supportiveText && (
          <p className={styles.supportiveText}>{supportiveText}</p>
        )}
        {trailingIcon && (
          <div className={styles.trailingIconContainer}>{trailingIcon}</div>
        )}
      </div>
      {separated && (
        <hr
          className={styles.separator}
          data-testid="dropdown-list-separator"
        />
      )}
    </>
  );
};
